import BaseApi from '../baseApi';

export default class NoticeApi extends BaseApi {
  constructor(obj) {
    obj = obj || {};
    super(obj);
  }

  findAll() {
    return this.api.get('/notices');
  }

  add(notice) {
    return this.api.post('/notices', notice);
  }

  update(id, notice) {
    return this.api.put(`/notices/${id}`, notice);
  }

  cancel(id) {
    return this.api.patch(`/notices/${id}/cancel`);
  }

  findPending() {
    return this.api.get('/notices/pending');
  }

  markRead(id) {
    return this.api.post(`/notices/${id}/read`);
  }
}
